module.exports = __webpack_public_path__ + "img/symbol_5.271d3a5a.png";